import React from 'react';
import { connect } from 'react-redux';
import { fetchEventDetails } from '../../actions/event';
import { fetchResponses } from '../../actions/responses';
import Logger from '../../util/Logger';
import ErrorAndRefresh from '../shared/ErrorAndRefresh';
import LoadingAndPulse from '../shared/LoadingAndPulse';
import { NETWORK_CODE_NOT_FOUND } from '../../constants';
import { handleErrorWithDialog } from '../../util/Errors';
import Event from '../../models/Event';
import './CommentsBySentiment.css';
import SentimentSadIcon from '../../images/sentiment_sad.svg';
import SentimentNeutralIcon from '../../images/sentiment_neutral.svg';
import SentimentHappyIcon from '../../images/sentiment_happy.svg';
import EventStats from '../../models/EventStats';
import { EventQuestionType } from '../../models/EventQuestionType';

class CommentsBySentiment extends React.Component {

  constructor (props) {
    super(props);

    const { event, user } = props;
    if (!user) {
      Logger.assert('Missing user in QuestionStats component');
    }

    if (!event) {
      Logger.assert('Missing event in QuestionStats component');
    }
  }

  componentDidUpdate (prevProps) {
    const { error } = this.props;
    handleErrorWithDialog(error, prevProps.error, 'Unable to load Question Stats');
  }

  loadStats = () => {
    const { fetchEventDetails, fetchResponses, event } = this.props;
    fetchEventDetails(Event.getId(event));
    fetchResponses(Event.getId(event));
  };

  render () {
    const { loading, error, event, stats } = this.props;
    if (error) {
      return (
        <div className="comments-by-sentiment">
          <ErrorAndRefresh
            error="Unable to load Event"
            // If its a 404, hide the refresh button cause it doesn't exist anyway.
            onRefresh={ error.code === NETWORK_CODE_NOT_FOUND ? null : this.loadStats } />
        </div>
      );
    } else if (loading || !stats || !event) {
      // Else if we don't have stats or we are still loading
      return (
        <div className="comments-by-sentiment">
          <LoadingAndPulse
            size={ 20 }
            color="#3D9AE2"
            whatIsLoading="Average & Breakdown" />
        </div>
      );
    } else {
      const positive = EventStats.getPositiveSentimentCount(stats);
      const negative = EventStats.getNegativeSentimentCount(stats);
      const neutral = EventStats.getNeutralSentimentCount(stats);
      const total = positive + negative + neutral;

      const positivePercent = total ? parseFloat(((positive / total) * 100).toFixed(0)) : 0;
      const negativePercent = total ? parseFloat(((negative / total) * 100).toFixed(0)) : 0;
      const neutralPercent = total ? parseFloat(((neutral / total) * 100).toFixed(0)) : 0;
      return (
        <div className="col comments-by-sentiment d-flex h-100 print-card-header">
          <div className="row h-100 w-100 my-auto">
            <SentimentSection
              event={ event }
              icon={ SentimentHappyIcon }
              sentimentType="Positive"
              percentage={ positivePercent }
              commentCount={ positive }
              textColor="#3D9AE2"
            />
            <SentimentSection
              event={ event }
              icon={ SentimentNeutralIcon }
              sentimentType="Neutral"
              percentage={ neutralPercent }
              commentCount={ neutral }
              textColor="#909090"
            />
            <SentimentSection
              event={ event }
              icon={ SentimentSadIcon }
              sentimentType="Negative"
              percentage={ negativePercent }
              commentCount={ negative }
              textColor="#FF6646"
            />
          </div>
        </div>
      );
    }
  }
}

const SentimentSection = ({ event, icon, sentimentType, percentage, commentCount, textColor }) => {

  return (
    <div className="col-4 my-3 sentiment-section">
      <div className="row no-gutters">
        <div className="col-4 sentiment-image">
          <img src={ icon } alt={ sentimentType } />
        </div>
        <div className="col-8">
          <div className="row no-gutters">
            <div className="text-center sentiment-percentage col-6" style={ { color: textColor } }>
              { percentage }%
            </div>
            <div className="sentiment-type my-auto h-100 col-6">
              &nbsp;{ sentimentType }
            </div>
          </div>
          <div className="sentiment-count text-center">
            { commentCount }
            &nbsp;
            { EventQuestionType.isOpenEndedType(Event.getQuestionType(event))
              ? 'responses and comments'
              : 'comments' }
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const user = state.user.user;
  return {
    user: user,
    loading: state.event.statsLoading,
    error: state.event.statsError
  };
};

export default connect(mapStateToProps, {
  fetchEventDetails,
  fetchResponses
})(CommentsBySentiment);
